<div class="block min-w-80 max-w-80 text-left">
  <div
    class="-mx-2.5 -mt-2.5 w-full bg-gradient-to-bl via-white to-white px-2.5 py-2"
    [ngClass]="{
      'from-black/20': activityType?.reference === 'note',
      'from-turquoise-bright/30': activityType?.reference === 'email',
      'from-bright-green/30': activityType?.reference === 'call',
    }"
  >
    <div class="flex min-w-0 items-start justify-between gap-2">
      <div class="min-w-0 flex-1 text-left">
        <p class="m-0 text-[10px] font-medium uppercase tracking-[0.12em] text-grey-mid/80">Last activity</p>
        <h2 class="m-0 pt-0.5 text-[13px] font-medium leading-tight text-grey-blue">
          {{ activityType?.listTitle }}
        </h2>
        <div class="pt-0.5 text-xs text-grey-mid">
          {{ activity.attributes.created_at | amDateFormat: 'D MMM YYYY, HH:mm' }}
        </div>
      </div>
      @if (activityType) {
        <div
          class="inline-flex size-8 shrink-0 items-center justify-center rounded-xl p-1"
          [ngClass]="{
            'bg-black/10 text-black': activityType.reference === 'note',
            'bg-turquoise-bright/15 text-turquoise-bright': activityType.reference === 'email',
            'bg-bright-green/15 text-bright-green': activityType.reference === 'call',
          }"
        >
          <ion-icon [name]="activityType.icon" class="size-5"></ion-icon>
        </div>
      }
    </div>
  </div>

  <div class="pt-2.5">
    <div class="mt-2 whitespace-pre-line break-words text-xs font-normal text-grey-blue/80 italic">
      {{ activity.attributes.content }}
    </div>
  </div>
</div>
